import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  ICON_COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import { BREAKPOINTS } from "../../../constants/design/media";
import { BORDER_RADIUS, SPACING } from "../../../constants/design/spacing";

export const ScrollerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  /* Critical: prevents the wrapper from contributing its content's max-content
     to a parent grid/flex track. Without min-width: 0, content overflow can
     push parents to grow horizontally instead of clipping. */
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`;

export const ScrollViewport = styled.div<{ $hideScrollbar?: boolean }>`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;

  ${({ $hideScrollbar }) =>
    $hideScrollbar
      ? css`
          scrollbar-width: none;
          -ms-overflow-style: none;
          &::-webkit-scrollbar {
            display: none;
          }
        `
      : css`
          /* Thin, subtle scrollbar that matches the dark theme. */
          scrollbar-width: thin;
          scrollbar-color: ${BORDER_COLORS.three} transparent;

          &::-webkit-scrollbar {
            height: 6px;
          }
          &::-webkit-scrollbar-track {
            background: transparent;
          }
          &::-webkit-scrollbar-thumb {
            background: ${BORDER_COLORS.three};
            border-radius: ${BORDER_RADIUS.full}px;
          }
          &::-webkit-scrollbar-thumb:hover {
            background: ${TEXT_COLORS.three};
          }
        `}
`;

export const FadeEdge = styled.div<{ edge: "left" | "right" }>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 32px;
  pointer-events: none;
  z-index: 1;

  ${({ edge }) =>
    edge === "left"
      ? css`
          left: 0;
          background: linear-gradient(
            to right,
            ${LAYER_COLORS.one} 0%,
            rgba(0, 0, 0, 0) 100%
          );
        `
      : css`
          right: 0;
          background: linear-gradient(
            to left,
            ${LAYER_COLORS.one} 0%,
            rgba(0, 0, 0, 0) 100%
          );
        `}
`;

export const ScrollArrow = styled.button<{ edge: "left" | "right" }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid ${BORDER_COLORS.one};
  background: ${LAYER_COLORS.two};
  border-radius: ${BORDER_RADIUS.full}px;
  color: ${ICON_COLORS.one};
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);

  ${({ edge }) =>
    edge === "left"
      ? css`
          left: ${SPACING.one}px;
        `
      : css`
          right: ${SPACING.one}px;
        `}

  &:hover {
    background: ${LAYER_COLORS.three};
    color: ${TEXT_COLORS.one};
  }

  ${BREAKPOINTS.mobile} {
    display: none;
  }
`;
